
import { Category } from 'src/app/models/categories.model';
import { CategoryProd } from 'src/app/models/categoryProduct.model';
import { Product } from 'src/app/models/product.model';
import { MediaType } from 'src/app/services/multimedia.storage.service';


export const sequencedCategories = (allCategories: CategoryProd[]): CategoryProd[] => {
  if (!allCategories?.length) return [];

  return [...allCategories].sort((a, b) => {
    const aOutOfStock = a?.outOfStockStatus ? 1 : 0;
    const bOutOfStock = b?.outOfStockStatus ? 1 : 0;

    if (aOutOfStock !== bOutOfStock) {
      return aOutOfStock - bOutOfStock;
    }

    const aSeq = a?.categoryInfo?.sequence ?? Infinity;
    const bSeq = b?.categoryInfo?.sequence ?? Infinity;

    return aSeq - bSeq;
  });
};


export const getCATProduct = async (list, mediaService): Promise<Product[]> => {
  const productArray = [];
  for (let k = 0; k < list.length; k++) {
    const url = `${list[k]?.productInfo?.image?.baseUrl}tr:w-300:h-300:di-defaultImage.jpg/${list[k]?.productInfo?.image?.imageBasePath}`
    const media = await mediaService.getStoredMediaByUrl(url, MediaType.IMAGE);
    const src = mediaService.createMediaUrl(media);
    const obj = {
      id: list[k]?.productInfo?._id ? list[k]?.productInfo?._id : list[k]._id,
      skuCode: '',
      name: list[k]?.metaInfo?.itemName.toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' '),
      desc: list[k]?.productInfo?.description || '',
      pic: '',
      quantity: 0,
      price: list[k]?.metaInfo?.price,
      isVeg: list[k]?.productInfo?.['veg/nonVeg'] ? list[k]?.productInfo?.['veg/nonVeg'].toLowerCase() === 'veg' ? true : false : '',
      // pId: `${list[k]?.productInfo?.image?.baseUrl}tr:w-300:h-300:di-defaultImage.jpg/${list[k]?.productInfo?.image?.imageBasePath}`,
      pId: src,
      display: `${list[k]?.productInfo?.image?.baseUrl}tr:w-600:h-600:di-defaultImage.jpg/${list[k]?.productInfo?.image?.imageBasePath}`,
      metaInfo: list[k]?.metaInfo,
      regionalLanguage: list[k]?.productInfo?.regionalLanguage,
      groups: list[k]?.metaInfo?.groups,
      addOnAvailable: false,
      addOnProds: [],
      productPrice: list[k]?.metaInfo?.price,
      addedIds: [],
      addOnProdIds: list[k]?.metaInfo?.addOns,
      productInfo: list[k]?.productInfo,
    };
    productArray.push(obj);

  }
  return productArray;

};

export const getUpdatedCategoriesWithProducts = async (list: any[], store: string, mediaService) => {
  try {
    const updatedCategories = list.map(category => ({
      ...category,
      categoryInfo: { ...category.categoryInfo },
      products: category.products ? [...category.products] : []
    }));

    const updatedProducts: { [key: string]: any } = {};

    for (let i = 0; i < updatedCategories.length; i++) {
      const category = updatedCategories[i];

      try {
        const url = `${category?.categoryInfo.image.baseUrl}tr:w-300:h-300:di-defaultImage.jpg/${category?.categoryInfo.image.imageBasePath}`;
        const media = await mediaService.getStoredMediaByUrl(url, MediaType.IMAGE);
        const src = mediaService.createMediaUrl(media);
        updatedCategories[i] = {
          ...updatedCategories[i],
          categoryInfo: {
            ...updatedCategories[i].categoryInfo,
            pId: src
          }
        };
      } catch (mediaErr) {
        console.warn(`Media fetch failed for category ${category?._id}:`, mediaErr);
      }
      if (category?.productsCount) {
        try {
          const ss = await getCATProduct(category?.products, mediaService);
          const sortedProducts = ss?.sort((a, b) => a?.id.localeCompare(b?.id));

          updatedCategories[i] = {
            ...updatedCategories[i],
            products: sortedProducts
          };

          const prodKey = store + category._id;
          updatedProducts[prodKey] = sortedProducts;
        } catch (productErr) {
          console.warn(`Product fetch failed for category ${category?._id}:`, productErr);
        }
      }
    }

    return { updatedCategories, updatedProducts };

  } catch (err) {
    console.error('Unexpected error in getUpdatedCategoriesWithProducts:', err);
    return { updatedCategories: [], updatedProducts: {} };
  }
};


export const fillAddonProducts = (catProd: Category[], prodId: string) => {
  for (let i = 0; i < catProd?.length; i++) {
    for (let j = 0; j < catProd[i]?.products?.length; j++) {
      if (catProd[i]?.products?.[j]?.id === prodId) {
        return catProd[i]?.products?.[j];
      }
    }
  }
}

export const modProductKeys = (product) => {
  return {
    ...product,
    "name": product.itemName,
    "metaInfo": {
      "itemName": product.itemName,
      "price": product.price,
    },
    "productPrice": product.price,
  }
}

export const mergeUniqueCombos = (addonsCombo, productId: string) => {
  const addonsComboWithIds = addonsCombo.map((combo) => {
    const comboId = productId + getComboId(combo.combo)
    return { ...combo, comboId }
  });
  const mergedAddonsCombo = [];
  addonsComboWithIds.forEach((combo) => {
    if (!mergedAddonsCombo.find(({ comboId }) => combo.comboId === comboId)) {
      const uniqueCombo = addonsComboWithIds.find(({ comboId }) => combo.comboId === comboId);
      let quantity = 0;
      let price = 0;
      addonsComboWithIds.forEach((uc) => {
        if (uc.comboId === combo.comboId) {
          quantity += uc.quantity
          price += uc.price
        }
      })

      mergedAddonsCombo.push({
        ...uniqueCombo, quantity, price
      })
    }
  })
  return mergedAddonsCombo
}

export const getComboId = (selectedAddOns) => {
  let id = ''
  selectedAddOns.forEach(({ addOnProducts }) => {
    addOnProducts.forEach(({ isAdded, _id }) => {
      if (isAdded) {
        id += _id
      }
    })
  })
  return id
}
